import React from "react";
import { Box } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import ResultHeader from "../resultPage/ResultHeader";

const SkeletonLoader = () => {
  const SubjectBar = () => (
    <Box display="flex" gap={2} mb={1}>
      <Box display="flex" alignItems="center" gap={2}>
        <Skeleton variant="circle" width={12} height={12} />
        <Skeleton variant="text" width={35} height={16} />
      </Box>
      <Box display="flex" alignItems="center" gap={2}>
        <Skeleton variant="circle" width={12} height={12} />
        <Skeleton variant="text" width={35} height={16} />
      </Box>
      <Box display="flex" alignItems="center" gap={2}>
        <Skeleton variant="circle" width={12} height={12} />
        <Skeleton variant="text" width={35} height={16} />
      </Box>
    </Box>
  );

  const SubjectLength = () => (
    <Box display="flex" alignItems="center" gap={1} mb={1}>
      <Skeleton variant="text" width={20} height={16} />
      <Box component="span" fontSize="14px" color="text.secondary" />
      <Skeleton variant="text" width={20} height={16} />
    </Box>
  );

  // Skeleton Loading Component
  const SkeletonbBarLoader = () => (
    <Box px={2} mb={2}>
      {/* Header Skeleton */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={1}
      >
        <Skeleton variant="text" width={150} height={30} />
      </Box>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={1}
      >
        <SubjectBar />
        <SubjectLength />
      </Box>

      {/* Chart Area Skeleton */}
      <Box
        border="1px solid #e0e0e0"
        borderRadius="10px"
        overflow="hidden"
        mb={2}
      >
        <Skeleton
          variant="rect"
          width="100%"
          height={300}
        />
      </Box>

      {/* Additional chart sections */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={1}
      >
        <Skeleton
          variant="text"
          width={120}
          height={30}
        />
      </Box>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={1}
      >
        <SubjectBar />
        <SubjectLength />
      </Box>
      <Box
        border="1px solid #e0e0e0"
        borderRadius="10px"
        overflow="hidden"
        mb={2}
      >
        <Skeleton
          variant="rect"
          width="100%"
          height={250}
        />
      </Box>

      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={1}
      >
        <Skeleton variant="text" width={140} height={30} />
      </Box>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={1}
      >
        <SubjectBar />
        <SubjectLength />
      </Box>
      <Box
        border="1px solid #e0e0e0"
        borderRadius="10px"
        overflow="hidden"
        mb={2}
      >
        <Skeleton variant="rect" width="100%" height={250} />
      </Box>
    </Box>
  );

  // Toggle Buttons Skeleton
  const ToggleButtonsSkeleton = () => (
    <Box display="flex" justifyContent="flex-end" pr={2} mb={2}>
      <Box
        display="flex"
        border="1px solid #e0e0e0"
        borderRadius="4px"
        overflow="hidden"
      >
        <Skeleton
          variant="rect"
          width={80}
          height={36}
          style={{ marginRight: "1px" }}
        />
        <Skeleton variant="rect" width={80} height={36} />
      </Box>
    </Box>
  );
  return (
    <div>
      <ResultHeader testDisplayName="Analysis" path="/home-page" />
      <ToggleButtonsSkeleton />

      <SkeletonbBarLoader />
    </div>
  );
};

export default SkeletonLoader;
